export const THEME_IDS = {
  light: 'light',
  proDark: 'pro-dark',
  dracula: 'dracula',
  
};

export const THEMES = [
  { id: THEME_IDS.light, label: 'Light' },
  { id: THEME_IDS.proDark, label: 'Pro Dark' },
  { id: THEME_IDS.dracula, label: 'Dracula' },
];

export const normalizeTheme = (key) => {
  if (!key) return THEME_IDS.light;
  return (THEMES.some((t) => t.id === key) ? key : THEME_IDS.light);
};

const DARK_THEME_IDS = new Set([
  THEME_IDS.proDark,
  THEME_IDS.dracula,
  'dark',
]);

export const isDarkTheme = (themeId) =>
  themeId && DARK_THEME_IDS.has(String(themeId).toLowerCase());

export const defaultTheme = THEME_IDS.light;
